import { useLocation } from 'react-router-dom';
import { Row, Col, Typography } from 'antd';
import { useEffect, useState } from 'react';
import ProfileDropdown from '../ProfileDropdown';
const { Title } = Typography;
const waveImageUrl = `${process.env.PUBLIC_URL}/images/wave.png`;

// Page titles map, including some dynamic path segments
const pageTitles: { [key: string]: string } = {
    "/": "Genel Görünüm",
    "/profile": "Profil",
    "/course": "Kurs Listesi",
    "/my-course": "Kurslarım",
    "/reminder": "Takvim",
    "/live-lesson": "Canlı Ders",
    "/student-questions": "Sorular",
    "/exams": "Ödevler",
    "/support": "Destek",
    "/quizzes": "Sınavlar",
    "/ai-assistant": "Öğrenme Asistanı",
};

// Function to get the title based on the path
const getTitleFromPath = (pathname: string): string => {
    if (pageTitles[pathname]) return pageTitles[pathname];
    if (pathname.startsWith("/course/")) return "Kurs Detay";
    if (pathname.startsWith("/video/")) return "Kurs Detay";
    if (pathname.startsWith("/quiz/")) return "Sınav Detay";
    if (pathname.startsWith("/document/")) return "Doküman";
    if (pathname.startsWith("/video-list/")) return "Videolar";
    if (pathname.startsWith("/questions/")) return "Sınav";
    return "";
};

const PageHeader: React.FC = () => {
    const [firstName, setFirstName] = useState<string | null>()

    useEffect(() => {
        let firstName: string | null = localStorage.getItem('firstName')
        setFirstName(firstName)
    }, [])


    const location = useLocation();
    const pathname = location.pathname;
    const title = getTitleFromPath(pathname);

    return (
        <>
            {pathname === "/" ? (
                <Row gutter={[16, 0]} justify={"space-between"} className='page-header'>
                    <Col>
                        <Row align="middle">
                            <Title className='m-0 mt-8' level={4}><span style={{ fontWeight: 200 }}>Hoş geldin, </span> {firstName}</Title>
                            <img
                                src={waveImageUrl}
                                alt="El sallama"
                                className="welcome-wave"
                                width={27}
                                height={34}
                            />
                        </Row>
                    </Col>
                    <Col>
                        <Row gutter={[16, 0]}>
                            <Col>
                                <ProfileDropdown></ProfileDropdown>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            ) : (
                <Row gutter={[16, 0]} justify={"space-between"} className='mb-16 page-header'>
                    <Col>
                        <Title className="m-0 mt-8" level={3}>
                            {title}
                        </Title>
                    </Col>
                    <Col>
                        <Row gutter={[16, 0]}>
                            <Col>
                                <ProfileDropdown></ProfileDropdown>
                                {/* <NavLink to="/profile">
                                    <ProfileLink />
                                </NavLink> */}
                            </Col>
                        </Row>
                    </Col>
                </Row>
            )}
        </>
    );
};

export default PageHeader;
